export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'

export const CORE_LOAD_ALL_SERVICE_REQUEST = 'CORE_LOAD_ALL_SERVICE_REQUEST'
export const CORE_LOAD_ALL_SERVICE_SUCCESS = 'CORE_LOAD_ALL_SERVICE_SUCCESS'
export const CORE_LOAD_ALL_SERVICE_FAILURE = 'CORE_LOAD_ALL_SERVICE_FAILURE'

export const CORE_CHANGE_PREPARE_TO_SEND_REQUEST = 'CORE_CHANGE_PREPARE_TO_SEND_REQUEST'
export const CORE_CHANGE_PREPARE_TO_SEND_SUCCESS = 'CORE_CHANGE_PREPARE_TO_SEND_SUCCESS'
export const CORE_CHANGE_PREPARE_TO_SEND_FAILURE = 'CORE_CHANGE_PREPARE_TO_SEND_FAILURE'

export const CORE_CHANGE_SEND_TO_DONE_REQUEST = 'CORE_CHANGE_SEND_TO_DONE_REQUEST'
export const CORE_CHANGE_SEND_TO_DONE_SUCCESS = 'CORE_CHANGE_SEND_TO_DONE_SUCCESS'
export const CORE_CHANGE_SEND_TO_DONE_FAILURE = 'CORE_CHANGE_SEND_TO_DONE_FAILURE'

export const CORE_CHANGE_TO_REJECT_REQUEST = 'CORE_CHANGE_TO_REJECT_REQUEST'
export const CORE_CHANGE_TO_REJECT_SUCCESS = 'CORE_CHANGE_TO_REJECT_SUCCESS'
export const CORE_CHANGE_TO_REJECT_FAILURE = 'CORE_CHANGE_TO_REJECT_FAILURE'


// WEBPACK FOOTER //
// ./src/types.js